import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Arr } from '../../../helpers/Arr'
import { IElementProps } from '../../../types/interfaces'
import LicencePlateFlag from '../../common/LicencePlateFlag/LicencePlateFlag'

const ZipSearch = (props: IElementProps) => {
  const { t } = useTranslation('common')
  const [searchString, setSearchString] = useState(props?.value || '')

  const optionsToRender = props.externalData?.data
    ? Object.keys(props.externalData.data).map((key) => ({
        name: key,
        value: props.externalData!.data[key],
        tr: props.externalData!.tr ? props.externalData!.tr[key] : {},
      }))
    : []

  const handleChangeInt = (zip: string, location: string) => {
    const e = {
      target: {
        value: zip,
      },
    } as React.ChangeEvent<HTMLInputElement>
    setSearchString(zip)
    props.handleChange(props.name, e)
    props.locationsPrefill?.(zip, location)
  }

  const removeData = () => {
    props.handleChange(props.name)
    props.locationsPrefill?.('', '')
    setSearchString('')
  }

  const handleInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setSearchString(value)
    if (!value) {
      removeData()
    }
  }

  return (
    <>
      {props.visible && (
        <div className="formGroup">
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="input-area contract-search">
            <input
              readOnly={props.formReadOnly || props.disabledInput || props.disabledInput}
              name={`fieldnameveryunique${new Date().getTime()}`}
              key={props.name}
              type="text"
              value={searchString}
              autoComplete="none"
              list="autocompleteOff"
              onChange={(e) => handleInput(e)}
              className="required-highlight transparent"
              placeholder={t('ENTER_ZIP_INFO')}
            />
            <i className="icon-search" style={{ position: 'absolute', right: '5px' }} />
            {props.value && !(props.formReadOnly || props.disabledInput) && (
              <button title="Clear" className="clr-btn">
                <span className="icon-clear" onClick={() => removeData()}></span>
              </button>
            )}
            {Arr.any(optionsToRender) && (
              <div className="cantonsOptionArea">
                {optionsToRender
                  ?.sort((a, b) => a.name.localeCompare(b.name))
                  .map(
                    (el) =>
                      !props.value &&
                      searchString.length >= 3 &&
                      (el.name.toLowerCase().indexOf(searchString.toLowerCase()) > -1 ||
                        el.value.toLowerCase().indexOf(searchString.toLowerCase()) > -1) && (
                        <a className="cantonsOption" onClick={() => handleChangeInt(el.value, el.name)}>
                          <LicencePlateFlag
                            licenceNumber={props.externalData?.misc?.[el?.name]}
                            width="12"
                            height="14"
                          />
                          {el.value} - {el.name}{' '}
                        </a>
                      )
                  )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
export default ZipSearch
